import { render, staticRenderFns } from "./InformationalModal.vue?vue&type=template&id=6324a3d5&"
import script from "./InformationalModal.vue?vue&type=script&lang=js&"
export * from "./InformationalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6324a3d5')) {
      api.createRecord('6324a3d5', component.options)
    } else {
      api.reload('6324a3d5', component.options)
    }
    module.hot.accept("./InformationalModal.vue?vue&type=template&id=6324a3d5&", function () {
      api.rerender('6324a3d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modals/InformationalModal.vue"
export default component.exports